import { object, string, number } from 'yup';
export const Fields = [
  {
    name: 'otp',
    placeholder: 'Enter OTP',
    label: 'OTP',
    helper: true,
    maxLength: 6,
  },
];
export const validationSchema = object({
  otp: string()
    .required('Required')
    .matches(/^[0-9]+$/, 'OTP has to be number only'),
});
export const initialValues = {
  otp: '',
};
